export default [
  {
    path: "/",
    name: "home",
    meta: { title: "Beranda", authRequired: false },
    component: () => import("../views/pages/public/home/index"),
  },
  {
    path: "/cek-status",
    name: "cek-status",
    meta: { title: "Cek Status Kemiskinan", authRequired: false },
    component: () => import("../views/pages/public/cek-status.vue"),
  },
  {
    path: "/daftar-dtks",
    name: "daftar-dtks",
    meta: { title: "Pendaftaran DTKS Mandiri", authRequired: false },
    component: () => import("../views/pages/public/daftar-dtks.vue"),
  },
  {
    path: "/tracking-pendaftaran",
    name: "tracking-pendaftaran",
    meta: { title: "Cek Status Pendaftaran DTKS", authRequired: false },
    component: () => import("../views/pages/public/tracking-pendaftaran.vue"),
  },
  {
    path: "/lapor-kesalahan-bansos",
    name: "lapor-kesalahan-bansos",
    meta: { title: "Laporan Kesalahan Data Bansos", authRequired: false },
    component: () => import("../views/pages/public/lapor-kesalahan-bansos.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];
